import { add, qs, remove } from '@fluorescent/dom';
import { Ajaxinate } from 'ajaxinate';

import { section } from '@/glow';
import ProductItem from '@/lib/product-item';
import filterHandler from '@/lib/filters/filter-handler';
import filterDrawer from '@/lib/filters/filter-drawer';
import { emit } from '@/glow/events';
import { AnimateCollection } from '@/lib/animation';

const selectors = {
  infiniteScrollContainer: '.collection__infinite-container',
  infiniteScrollTrigger: '.collection__infinite-trigger',
  partial: '[data-partial]',
};

section('collection', {
  infiniteScroll: null,

  onLoad() {
    const { collectionItemCount, paginationType } = this.container.dataset;

    if (!parseInt(collectionItemCount)) return;

    this.filterForm = qs('[data-filter-form]', this.container);

    if (this.filterForm) {
      this.partial = qs(selectors.partial, this.container);

      this.filterDrawer = filterDrawer(this.container);
      this.filterHandler = filterHandler({
        container: this.container,
        partial: this.partial,
        renderCB: this._renderView.bind(this),
      });
    }

    // Ininite scroll
    this.paginationType = paginationType;
    this.paginated = this.paginationType === 'paginated';

    this.infiniteScrollTrigger = qs(
      selectors.infiniteScrollTrigger,
      this.container
    );

    if (!this.paginated) {
      this._initInfiniteScroll();
    }

    this.productItem = ProductItem(this.container);
    this.AnimateCollection = AnimateCollection(this.container);
  },

  _initInfiniteScroll() {
    const infiniteScrollOptions = {
      container: selectors.infiniteScrollContainer,
      pagination: selectors.infiniteScrollTrigger,
      loadingText: 'Loading...',
      callback: () => {
        this.productItem && this.productItem.unload();
        this.productItem = ProductItem(this.container);

        this.AnimateCollection.updateItems();

        emit('collection:updated');
      },
    };

    if (this.paginationType === 'click') {
      infiniteScrollOptions.method = 'click';
    }

    this.infiniteScroll = new Ajaxinate(infiniteScrollOptions);
  },

  _renderView(searchParams) {
    const url = `${window.location.pathname}?section_id=${this.container.dataset.sectionId}&${searchParams}`;
    const loading = qs('.collection__loading', this.container);

    add(loading, 'is-active');

    fetch(url)
      .then(res => res.text())
      .then(res => {
        this._updateURLHash(searchParams);
        const doc = new DOMParser().parseFromString(res, 'text/html');
        const contents = qs(selectors.partial, doc).innerHTML;
        this.partial.innerHTML = contents;

        if (!this.paginated) {
          this.infiniteScrollTrigger.innerHTML = '';

          this._initInfiniteScroll();
        }

        this.productItem && this.productItem.unload();
        this.productItem = ProductItem(this.container);

        this.AnimateCollection.updateItems();

        remove(loading, 'is-active');
        emit('collection:updated');
      });
  },

  _updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  },

  onUnload() {
    this.infiniteScroll && this.infiniteScroll.destroy();

    this.filtering && this.filtering.unload();

    this.delegate.off();
    this.subscriptions.forEach(unsubscribe => unsubscribe());

    this.productItem && this.productItem.unload();
    this.AnimateCollection?.destroy();
  },
});
